import { render, staticRenderFns } from "./TrainingDialogAdviceDialog.vue?vue&type=template&id=08660dd4&scoped=true&"
import script from "./TrainingDialogAdviceDialog.vue?vue&type=script&lang=js&"
export * from "./TrainingDialogAdviceDialog.vue?vue&type=script&lang=js&"
import style0 from "./TrainingDialogAdviceDialog.vue?vue&type=style&index=0&id=08660dd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08660dd4",
  null
  
)

export default component.exports